// Dependencies
import { all, call, takeEvery, fork, put } from "@redux-saga/core/effects";

// Action Types
import {
    PACKAGES_OVERVIEW_REQUEST
} from 'Redux/actionTypes';

// Actions
import {
    packagesOverviewResult,
} from 'Redux/actions';

// Helpers
import { clientQuery } from 'Core/data/GraphQLApi';
import { endpoints } from 'Core/defaultValues';
import { ExceptionManager } from 'Core/logManager';

function* getPackage({ payload }) {
    try {
        let QUERY = `
            query getRole ($id: Int!) {
                result: getRole (id: $id) {
                    id
                    projectId
                    companyId
                    dealerId
                    name
                    description
                    isCustom
                    customOwner
                }
            }
        `;

        let data = yield call(
            clientQuery,
            QUERY,
            {
                id: payload
            },
            endpoints.GRAPHQL_GENERAL,
        );

        yield put(packagesOverviewResult(data?.result))

    } catch (exc) {
        yield put(packagesOverviewResult({ error: exc }))
    }
}

function* watchMethods() {
    yield takeEvery(PACKAGES_OVERVIEW_REQUEST, getPackage);
}

export default function* rootSaga() {
    yield all([fork(watchMethods)]);
}